import {
  onUnmounted, onMounted,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useTaskModalStore } from '@/stores/useTaskModalStore.js';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useTimeoutPoll } from '@vueuse/core';

export default function useTaskModal() {
  const {
    localTasks,
    numLocalInProgressTasks,
    inProgressLocal,
    tasks,
    inProgressTasks,
    completeTasks,
    errorTasks,
    terminatedTasks,
    numInProgressTasks,
    numCompletedTasks,
    inProgress,
    numErrorTasks,
    numTerminatedTasks,
    showTasksModal,
    mode,
  } = storeToRefs(useTaskModalStore());

  const {
    $reset,
  } = useTaskModalStore();

  const { isActive: isGettingTasks, pause: pauseGetTasks, resume: resumeGetTasks } = useTimeoutPoll(getTasks, 5000);

  async function getTasks() {
    const dataConnect = new DatastoreConnect();

    const response = await dataConnect.listTasks()
      .catch((e) => {
        console.log(e);
      });

    if (response.result) {
      tasks.value = response.result.tasks;
    }

    tasks.value = tasks.value.filter((e) => {
      let dataJson = {};
      if (typeof e.data === 'string') {
        if (e.data !== "") {
          dataJson = JSON.parse(e.data);
        } else {
          dataJson = {};
        }
      } else if (typeof e.data === 'object') {
        dataJson = e.data;
      }
      return "stage_definitions" in dataJson;
    });

    tasks.value.sort((a, b) => a.id - b.id);

    if (tasks.value) {
      inProgressTasks.value = tasks.value.filter((e) => !e.status.toLowerCase().includes('complete')
                                                        && !e.status.toLowerCase().includes('error')
                                                        && !e.status.toLowerCase().includes('terminate'));
      completeTasks.value = tasks.value.filter((e) => e.status.toLowerCase().includes('complete'));
      errorTasks.value = tasks.value.filter((e) => e.status.toLowerCase().includes('error'));
      terminatedTasks.value = tasks.value.filter((e) => !e.status.toLowerCase().includes('error'));
    }

    // Update local tasks
    localTasks.value = localTasks.value
      .map((localTask) => {
        const foundLocalTask = inProgressTasks.value.find((t) => t.id === localTask.id);
        if (foundLocalTask) {
          return foundLocalTask; // replace with the one from inProgressTasks
        } else {
          return null; // mark for removal
        }
      })
      .filter((task) => task !== null); // remove tasks that were not found
  }

  return {
    localTasks,
    numLocalInProgressTasks,
    inProgressLocal,
    tasks,
    inProgressTasks,
    completeTasks,
    errorTasks,
    terminatedTasks,
    numInProgressTasks,
    numCompletedTasks,
    inProgress,
    numErrorTasks,
    numTerminatedTasks,
    showTasksModal,
    mode,
    getTasks,
    pauseGetTasks,
    resumeGetTasks,
    isGettingTasks,
  };
}
